const primarydealerfiles = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/primarydealerfiles/primarydealerfiles.vue')), 'primarydealerfiles')
const secondarydealerfiles = r => require.ensure([], () => r(require(
		'../../views/basicarchivesmanagement/secondarydealerfiles/secondarydealerfiles.vue')),
	'secondarydealerfiles')
const relationcustomerfiles = r => require.ensure([], () => r(require(
		'../../views/basicarchivesmanagement/relationcustomerfiles/relationcustomerfiles.vue')),
	'relationcustomerfiles')
const customerScore = r => require.ensure([], () => r(require(
		'../../views/basicarchivesmanagement/customerScore/customerScore.vue')),
	'customerScore')
const productlinefile = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/productlinefile/productlinefile.vue')), 'productlinefile')
const productfile = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/productfile/productfile.vue')), 'productfile')
const Product = r => require.ensure([], () => r(require('../../views/basicarchivesmanagement/Product/Product.vue')),
	'Product')
const warehousearchives = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/warehousearchives/warehousearchives.vue')), 'warehousearchives')
const hospitalarchives = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/hospitalarchives/hospitalarchives.vue')), 'hospitalarchives')
const dealerhospitalmaintenanceindicators = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/dealerhospitalmaintenanceindicators/dealerhospitalmaintenanceindicators.vue'
)), 'dealerhospitalmaintenanceindicators')
const salesarea = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/salesarea/salesarea.vue')), 'salesarea')
const businesshospitalrelationship = r => require.ensure([], () => r(require(
		'../../views/basicarchivesmanagement/businesshospitalrelationship/businesshospitalrelationship.vue')),
	'businesshospitalrelationship')
const salesmanlevel = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/salesmanlevel/salesmanlevel.vue')), 'salesmanlevel')
const DSPHF = r => require.ensure([], () => r(require('../../views/basicarchivesmanagement/DSPHF/badsphf.vue')),
	'DSPHF')
const productstandard = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/productstandard/productstandard.vue')), 'productstandard')
const ProviderApproval = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/ProviderApproval/ProviderApproval.vue')), 'ProviderApproval')
const Manufacturer = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/Manufacturer/Manufacturer.vue')), 'Manufacturer')


const CostSetting = r => require.ensure([], () => r(require(
	'../../views/priceSetting/CostSetting/CostSetting.vue')), 'CostSetting')
const CostSummary = r => require.ensure([], () => r(require(
	'../../views/priceSetting/CostSummary/CostSummary.vue')), 'CostSummary')

const InventoryProvince = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/inventoryProvince/inventoryProvince.vue')), 'InventoryProvince')
const UnitConvert = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/unitConvert/unitConvert.vue')), 'UnitConvert')
const NTSInvClassQuota = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/NTSInvClassQuota/NTSInvClassQuota.vue')), 'NTSInvClassQuota')
const LEVEL = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/level/level.vue')), 'LEVEL')

const GradeState = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/GradeState/GradeState.vue')), 'GradeState')

const ReportBuyer = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/ReportBuyer/ReportBuyer.vue')), 'ReportBuyer')

const BOSSCustomer = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/BOSSCustomer/BOSSCustomer.vue')), 'BOSSCustomer')

const OrganizationRebate = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/OrganizationRebate/OrganizationRebate.vue')), 'OrganizationRebate')

const OrgNTSQuota = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/OrgNTSQuota/OrgNTSQuota.vue')), 'OrgNTSQuota')

const TechnicalOffices = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/TechnicalOffices/TechnicalOffices.vue')), 'TechnicalOffices')

const OrgStockMoneyChangeAdjust = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/OrgStockMoneyChangeAdjust/OrgStockMoneyChangeAdjust.vue')), 'OrgStockMoneyChangeAdjust')

const SalesTactics = r => require.ensure([], () => r(require(
	'../../views/basicarchivesmanagement/SalesTactics/SalesTactics.vue')), 'SalesTactics')

const basucarchivemanageChildrenRouter = [{
		path: '/BA/BaOrganization',
		name: 'primarydealerfiles',
		component: primarydealerfiles,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/Customer',
		name: 'secondarydealerfiles',
		component: secondarydealerfiles,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/RelationCustomer',
		name: 'relationcustomerfiles',
		component: relationcustomerfiles,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/CustomerScore',
		name: 'customerScore',
		component: customerScore,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/InventoryClass',
		name: 'productlinefile',
		component: productlinefile,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/Product',
		name: 'Product',
		component: Product,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/Inventory',
		name: 'productfile',
		component: productfile,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/Warehouse',
		name: 'warehousearchives',
		component: warehousearchives,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/Hospital',
		name: 'hospitalarchives',
		component: hospitalarchives,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/CustomerQuota',
		name: 'dealerhospitalmaintenanceindicators',
		component: dealerhospitalmaintenanceindicators,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/Region',
		name: 'salesarea',
		component: salesarea,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/CusHosPerson',
		name: 'businesshospitalrelationship',
		component: businesshospitalrelationship,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/PersonGradation',
		name: 'salesmanlevel',
		component: salesmanlevel,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/CusProviderHos',
		name: 'DSPHF',
		component: DSPHF,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/InvStandardCost',
		name: 'productstandard',
		component: productstandard,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/ProviderApproval',
		name: 'ProviderApproval',
		component: ProviderApproval,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/Manufacturer',
		name: 'Manufacturer',
		component: Manufacturer,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/CostSetting',
		name: 'CostSetting',
		component: CostSetting,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/CostSummary',
		name: 'CostSummary',
		component: CostSummary,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/GradeState',
		name: 'GradeState',
		component: GradeState,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/InventoryProvince',
		name: 'InventoryProvince',
		component: InventoryProvince,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/UnitConvert',
		name: 'UnitConvert',
		component: UnitConvert,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/NTSInvClassQuota',
		name: 'NTSInvClassQuota',
		component: NTSInvClassQuota,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/LEVEL',
		name: 'LEVEL',
		component: LEVEL,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/ReportBuyer',
		name: 'ReportBuyer',
		component: ReportBuyer,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/BOSSCustomer',
		name: 'BOSSCustomer',
		component: BOSSCustomer,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/OrganizationRebate',
		name: 'OrganizationRebate',
		component: OrganizationRebate,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/OrgNTSQuota',
		name: 'OrgNTSQuota',
		component: OrgNTSQuota,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/TechnicalOffices',
		name: 'TechnicalOffices',
		component: TechnicalOffices,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/OrgStockMoneyChangeAdjust',
		name: 'OrgStockMoneyChangeAdjust',
		component: OrgStockMoneyChangeAdjust,
		meta: {
			typePage: 2
		}
	},
	{
		path: '/BA/SalesTactics',
		name: 'SalesTactics',
		component: SalesTactics,
		meta: {
			typePage: 2
		}
	},
];
export default basucarchivemanageChildrenRouter